import useSaveFilterSetCTA from './useSaveFilterSetCTA';
import {
  LBButton,
  LBCheckbox,
  LBChevronRightIcon,
  LBLabel
} from '@linearb/buzz';

const SaveFilterSetCTA = ({ Context, onClose }) => {
  const {
    dontShowAgain,
    setDontShowAgain,
    onApplyWithoutSaving,
    onProccedToSave
  } = useSaveFilterSetCTA({ Context, onClose });

  return (
    <div className='py-4 px-8' data-cy='suggest-to-save-filter-modal'>
      <header className='text-lg my-2'>Apply Filters</header>
      <main>
        Would you like to save these filters for future use?
        <div className='flex flex-row space-x-2 mt-2 items-center'>
          <LBCheckbox
            id='show-again'
            checked={dontShowAgain}
            onCheckedChange={(checked: boolean) => setDontShowAgain(checked)}
          />
          <LBLabel htmlFor='show-again'>Don't show this message again</LBLabel>
        </div>
      </main>
      <footer className='w-full mt-8 flex flex-col justify-center md:flex-row items-center gap-2 md:justify-between'>
        <LBButton variant='outline' onClick={onApplyWithoutSaving}>
          Apply without saving
        </LBButton>
        <LBButton onClick={onProccedToSave}>
          Proceed to Save <LBChevronRightIcon />
        </LBButton>
      </footer>
    </div>
  );
};

export default SaveFilterSetCTA;
